import { API_URL } from './config';

const TOKEN_KEY = 'nexslot_token';
const USER_KEY = 'nexslot_user';

export const auth = {
  getToken: (): string | null => localStorage.getItem(TOKEN_KEY),
  getUser: (): any | null => {
    const raw = localStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  },
  setSession: (token: string, user: any) => {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  },
  clearSession: () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
  },
  isAuthenticated: (): boolean => !!localStorage.getItem(TOKEN_KEY),
};

// Fetch wrapper — injects Bearer token automatically
export const apiFetch = async (path: string, options: RequestInit = {}): Promise<any> => {
  const token = auth.getToken();
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...(options.headers as Record<string, string>),
  };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const res = await fetch(`${API_URL}${path}`, { ...options, headers });
  const data = await res.json();

  if (res.status === 401) {
    auth.clearSession();
    window.location.href = window.location.origin;
  }

  return data;
};
